<template>
<v-app>
    <v-container fluid class="p-0 fill-height">
        <v-main>
            <slot />
        </v-main>
    </v-container>
</v-app>
</template>
